import { Point } from "pixi.js";
import { AbstractGameView } from "@lib/titan2-slingo/dist/game/view/abstract/display/AbstractGameView";
import { TitanSpine } from "@lib/titan2/dist/game/control/TitanSpine";
import { SpineComplete, SpineEvent } from "../../../../../utils/SpineUtils";
export class Trail extends AbstractGameView {
    constructor(factory, landscapeProperties, portraitProperties) {
        super(factory, landscapeProperties, portraitProperties);
        this.bendAngle = 40;
    }
    create() {
        this.spine = TitanSpine.createSpine(this, "trail-spine", this.landscapeProperties, this.portraitProperties);
        this.spine.responsive = false;
        this.responsive = false;
    }
    setSpeed(speed) {
        this.spine.getSpine().state.timeScale = speed;
    }
    play(startPositionGlobal, endPositionGlobal) {
        this.setBones(this.toLocal(startPositionGlobal), this.toLocal(endPositionGlobal));
        this.spine.play("trail");
        return { complete: SpineComplete(this.spine), impact: SpineEvent(this.spine, "impact") };
    }
    setBones(start, target) {
        const to = new Point(target.x - start.x, target.y - start.y);
        const targetDistance = Math.sqrt(to.x * to.x + to.y * to.y);
        this.setBonePosition(1, new Point(0, 0));
        this.setBonePosition(2, new Point(targetDistance, 0));
        this.setBoneRotation(2, this.bendAngle * (to.x > 0 ? -1 : 1));
        this.spine.position.set(start.x, start.y);
        this.spine.rotation = Math.atan2(to.y, to.x);
    }
    setBonePosition(boneIndex, position) {
        this.spine.getSkeleton().bones[boneIndex].x = position.x;
        this.spine.getSkeleton().bones[boneIndex].y = -position.y;
    }
    getBonePosition(boneIndex) {
        return {
            x: this.spine.getSkeleton().bones[boneIndex].x,
            y: this.spine.getSkeleton().bones[boneIndex].y
        };
    }
    setBoneRotation(boneIndex, rotation) {
        this.spine.getSkeleton().bones[boneIndex].rotation = rotation;
    }
    destroy() {
        this.spine.destroy();
        this.spine = undefined;
        super.destroy();
    }
}
//# sourceMappingURL=Trail.js.map